const socket = (() => {
  const log = (...data) => console.log("[socket-client]", ...data);
  log("Initializing");
  try {
    const { token, url } = socketOptions;
    const parsedUrl = new URL(url);
    log("Starting connection attempts to", url);
    const s = io(parsedUrl.origin, {
      path: parsedUrl.pathname,
      transports: ["websocket"],
      query: {
        token,
      },
    });
    s.on("connect", () => {
      log("Connected");
    });
    s.on("disconnect", (reason) => {
      log("Disconnected:", reason);
    });
    return s;
  } catch (e) {
    log("Error while initializing:", e);
    return undefined;
  }
})();
